export default "__VITE_ASSET__BuTbjR_B__"